import Vue from 'vue';
import ElementUI from 'element-ui';
import BrowserLogger from 'alife-logger';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/element-variables.scss';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import VCharts from 'v-charts';
import 'v-charts/lib/style.css';
import VueClipboard from 'vue-clipboard2';
import { HAS_MOCK, getEnv } from './config';
import App from './App';
import router from './router';
import store from './store';
import './permission';
import './global-components';
import './icons';
import * as filters from './filters';
import * as directives from './directives';
import globalMixin from './mixins';
import { getAccount } from '@/utils/account';
import SlsTracker from '@aliyun-sls/web-track-browser';

// register global filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// register global directives.
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

// custom global api
Vue.prototype.$has = function $has(code) {
  const hasAuth = store.state.menu.authList.some((item) => item.menuCode === code);
  return hasAuth;
};

Vue.prototype.$refreshSelectedTag = function $refreshSelectedTag(view) {
  this.$store.dispatch('tagsView/delCachedView', view).then(() => {
    const { fullPath } = view;
    this.$nextTick(() => {
      this.$router.replace({
        path: `/redirect${fullPath}`,
      });
    });
  });
};
// 字符串转数组
Vue.prototype.$stringToArray = function $stringToArray(str, code = ',') {
  if (!str) {
    return [];
  }
  const arr = str.split(code);
  return arr.filter((item) => !!item) || [];
};

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
if (process.env.NODE_ENV === 'development' && HAS_MOCK) {
  // eslint-disable-next-line global-require
  const { mockXHR } = require('../mock');
  mockXHR();
}
if (process.env.NODE_ENV === 'production' && ['prod'].includes(getEnv())) {
  const bl = BrowserLogger.singleton({
    pid: 'fjly4i49ou@8be1f6c0169e603',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    enableApiCors: true,
    behavior: true,
  });
  const environment = getEnv() === 'prod' ? 'prod' : 'daily';

  bl.setConfig({
    // prod表示线上环境。gray表示灰度环境。pre表示预发环境。daily表示日常环境。
    environment,
  });
  const userInfo = getAccount();
  if (userInfo !== null) {
    bl.setConfig({
      uid: userInfo.userId,
      setUsername() {
        return `username_${userInfo.userName}`;
      },
    });
  }
  Vue.prototype.$bl = bl;
}

const opts = {
  host: 'cn-shenzhen.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com（固定值）
  project: 'finance-frontend-sls', // Project名称。（固定值）
  logstore: process.env.NODE_ENV === 'production' && ['prod'].includes(getEnv()) ? 'prod_finance-service-static' : 'dev_finance-service-static', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 20, // 发送日志的数量大小，默认是10条。
};
const trackerLog = new SlsTracker(opts);
// 把实例挂载到window上，
window.slsWebTracker = trackerLog;

Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
    backdrop: false,
  },
});
Vue.use(VCharts);
Vue.use(VueClipboard);

// 全局mixins
Vue.mixin(globalMixin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
